import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-white border-t border-gray-100" data-id="element-58">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-59">
        <div className="flex flex-col md:flex-row items-center gap-8 bg-gradient-to-br from-green-50 to-emerald-50 p-10 rounded-3xl border border-green-100 shadow-sm" data-id="element-60">
          <div className="flex-shrink-0 bg-white p-4 rounded-full shadow-sm" data-id="element-61">
            <ShieldCheck className="w-20 h-20 text-green-600" data-id="element-62" />
          </div>
          <div className="text-center md:text-left" data-id="element-63">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-64">
              Garantía de Satisfacción de 7 Días
            </h3>
            <p className="text-gray-700 leading-relaxed text-lg" data-id="element-65">
              Estamos tan seguros de que{' '}
              <span className="font-bold" data-id="element-66">PACK INGLÉS LISTO™</span> va a
              transformar tu forma de trabajar que te damos 7 días para
              probarlo. Si sentís que no te ahorra tiempo o no es lo que
              esperabas, te devolvemos el 100% de tu dinero. Sin preguntas.{' '}
              <span className="font-bold text-green-700" data-id="element-67">
                El riesgo es todo nuestro.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}